<template>
  <div :class="['checkbox-wrapper', { disabled: isDisabled }]">
    <div class="checkbox-input">
      <input type="checkbox" class="checkbox" :id="id" :disabled="isDisabled" v-model="checkedRef" @change="onChange" />
      <span class="checkbox-input__fake" aria-hidden="true" @click="onFakeClick">
        <CheckIcon color="white" />
      </span>
    </div>
    <label class="checkbox-label" :for="id">
      <span>{{ label }}</span>
    </label>
  </div>
</template>

<script setup lang="ts">
import { ref, toRef, watch } from 'vue'

import CheckIcon from '@/features/ui/components/icons/check-icon.vue'

interface InputPropsType {
  id: string
  label?: string
  value?: string | null
  isDisabled?: boolean
  defaultChecked?: boolean
}

const props = defineProps<InputPropsType>()
const emit = defineEmits(['emit:change'])

const defaultCheckedRef = toRef(props, 'defaultChecked')
const checkedRef = ref(defaultCheckedRef.value || false)

watch(defaultCheckedRef, (newVal) => {
  checkedRef.value = newVal ?? false
})

const onChange = (event: Event) => {
  const value = (event.target as HTMLInputElement).checked
  emit('emit:change', value)
}

const onFakeClick = () => {
  if (props.isDisabled) return
  checkedRef.value = !checkedRef.value
  emit('emit:change', checkedRef.value)
}
</script>

<style scoped lang="scss">
@import './custom-checkbox.scss';
</style>
